export const courseCategories = [
  { key: 'desarrollo', name: 'Desarrollo', aliases: ['programacion', 'desarrollo web'] },
  { key: 'negocios', name: 'Negocios', aliases: ['emprendimiento', 'empresa'] },
  { key: 'finanzas', name: 'Finanzas', aliases: ['finanzas e inversion', 'inversion'] },
  { key: 'ti-y-software', name: 'TI y Software', aliases: ['ti', 'software', 'tecnologia'] },
  { key: 'productividad', name: 'Productividad', aliases: ['productividad personal', 'gestion del tiempo'] },
  { key: 'diseno', name: 'Diseño', aliases: ['diseno', 'diseno grafico'] },
  { key: 'marketing', name: 'Marketing', aliases: ['marketing digital'] },
  { key: 'salud-y-fitness', name: 'Salud y Fitness', aliases: ['salud', 'fitness', 'bienestar'] }
];

export const normalizeCategory = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

export const findCategoryConfig = (value = '') => {
  const normalizedValue = normalizeCategory(value);

  return courseCategories.find((category) => {
    const names = [category.name, ...(category.aliases || [])];
    return names.some((name) => normalizeCategory(name) === normalizedValue);
  });
};

export const courseMatchesCategory = (course, categoryName) => {
  if (!categoryName) {
    return true;
  }

  const selectedCategory = findCategoryConfig(categoryName);
  const courseCategory = findCategoryConfig(course?.category || '');

  if (!selectedCategory || !courseCategory) {
    return normalizeCategory(course?.category) === normalizeCategory(categoryName);
  }

  return selectedCategory.key === courseCategory.key;
};
